import * as core from '../../../../../../../core'
import * as sr from '../sr'

export const RESOURCE = {
  payload: {
    alias: 'subrecipient-details',
    appAlias: sr.RESOURCE.payload.alias,
    description: 'Subrecipient Details',
    display: {
      isMain: false,
      position: 7,
    },
    name: 'Subrecipient Details',
    page: { alias: 'sr:subrecipient-details' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
